import React from "react";
import { Card, Col, Button } from "antd";
import DoughnutChart from "./DoughnutChart";

const SkillTagChart = ({ chartData, skillTagPermission, onViewReport }) => {
  return (
    <Col span={24} md={12}>
      <Card
        bordered={false}
        className="criclebox tablespace"
        style={{ marginBottom: "16px" }}
      >
        <div className="dashboard-tables-main-heading">
          <p className="dashboard-table-heading">Skill Tag</p>
          {skillTagPermission ? (
            <Button onClick={onViewReport}>
              View Detailed Report
            </Button>
          ) : (
            ""
          )}
        </div>

        <DoughnutChart
          chartData={chartData}
          title="Skill Tags"
        />
      </Card>
    </Col>
  );
};

export default SkillTagChart;
